__turbopack_context__.v({
  "bodyContent": "Z8lDea_bodyContent",
  "centeredSection": "Z8lDea_centeredSection",
  "closeButton": "Z8lDea_closeButton",
  "contentWrapper": "Z8lDea_contentWrapper",
  "ctaButton": "Z8lDea_ctaButton",
  "divider": "Z8lDea_divider",
  "dropdownFadeIn": "Z8lDea_dropdownFadeIn",
  "dropdownGroup": "Z8lDea_dropdownGroup",
  "dropdownMenu": "Z8lDea_dropdownMenu",
  "dropdownOption": "Z8lDea_dropdownOption",
  "dropdownTrigger": "Z8lDea_dropdownTrigger",
  "dropdownWrapper": "Z8lDea_dropdownWrapper",
  "fadeInAnimation": "Z8lDea_fadeInAnimation",
  "footer": "Z8lDea_footer",
  "footerDetails": "Z8lDea_footerDetails",
  "footerRow": "Z8lDea_footerRow",
  "footerSubtitle": "Z8lDea_footerSubtitle",
  "footerTitle": "Z8lDea_footerTitle",
  "header": "Z8lDea_header",
  "headerButtonWrapper": "Z8lDea_headerButtonWrapper",
  "headerContent": "Z8lDea_headerContent",
  "headerImageWrapper": "Z8lDea_headerImageWrapper",
  "headerSubtitle": "Z8lDea_headerSubtitle",
  "headerTextContent": "Z8lDea_headerTextContent",
  "headerTitle": "Z8lDea_headerTitle",
  "heroImage": "Z8lDea_heroImage",
  "lgHidden": "Z8lDea_lgHidden",
  "modalContainer": "Z8lDea_modalContainer",
  "modalContentWithPadding": "Z8lDea_modalContentWithPadding",
  "modalOverlay": "Z8lDea_modalOverlay",
  "optionTitle": "Z8lDea_optionTitle",
  "optionValue": "Z8lDea_optionValue",
  "serialNumberInput": "Z8lDea_serialNumberInput",
  "serialNumberTip": "Z8lDea_serialNumberTip",
  "smHidden": "Z8lDea_smHidden",
  "step": "Z8lDea_step",
  "stepIcon": "Z8lDea_stepIcon",
  "stepsSection": "Z8lDea_stepsSection",
  "termsSection": "Z8lDea_termsSection",
  "translateUpAnimation": "Z8lDea_translateUpAnimation",
  "triggerContent": "Z8lDea_triggerContent",
  "triggerTitle": "Z8lDea_triggerTitle",
  "triggerValue": "Z8lDea_triggerValue",
  "uhxBonusBanner": "Z8lDea_uhxBonusBanner",
});
